<template>
  <div class="head">
    <div class="voo-block">
      <div class="voo-card ma-2 head-card">
        <div class="voo-subtitle black pl-2">VOOWE</div>
        <v-btn variant="flat" rounded="xl" color="black" class="voo-btn strong-btn text-none" @click="goTo('/order')">
			ЗАЯВКА
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
		methods: {
			goTo(path) {
				this.show = false;
				this.$router.push(path);
			},
		},
	};
</script>
<style scoped>
.head {
  position: fixed;
  z-index: 1000;
  width: 100%;
}

.head-card {
  background-color: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(3px);
  padding: 0px 10px;
  min-height: 60px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border-radius: 20px !important;
}
</style>
